import type { InvoiceCustomStyle } from "../types/invoiceCustomStyle.types";
import { defaultInvoiceCustomStyle } from "./defaultInvoiceCustomStyle";

export type InvoiceStylePresetName = "flownect" | "classic" | "modern" | "minimal";

const cloneDefaultStyle = (): InvoiceCustomStyle => structuredClone(defaultInvoiceCustomStyle);

export const invoiceStylePresets: Record<InvoiceStylePresetName, InvoiceCustomStyle> = {
  flownect: cloneDefaultStyle(),

  classic: {
    ...cloneDefaultStyle(),

    colors: {
      ...defaultInvoiceCustomStyle.colors,

      pageBackground: "#FFFCF5",
      emailHeader: "#FEF3C7",
      cardBackground: "#FFFFFF",

      title: "#2D3748",
      subTitle: "#744210",
      body: "#4A5568",

      border: "var(--fx-surface-border, #E2E8F0)",
      total: "#B7791F",
      icon: "#B7791F",
    },

    typography: {
      ...defaultInvoiceCustomStyle.typography,
      fontFamily: "Merriweather",
      headingFontFamily: "Merriweather",
    },

    borders: {
      ...defaultInvoiceCustomStyle.borders,
      color: "#E2E8F0",
      width: 1,
      radius: 10,
      style: "solid",
    },

    spacing: {
      ...defaultInvoiceCustomStyle.spacing,
      cardGap: 12,
    },

    icons: {
      ...defaultInvoiceCustomStyle.icons,
      service: "cleaning",
      visits: "calendar",
      location: "location",
      notes: "document",
      payment: "payment",
      additionalCharges: "assignment",
    },
  },

  modern: {
    ...cloneDefaultStyle(),

    colors: {
      ...defaultInvoiceCustomStyle.colors,

      pageBackground: "#F8FAFC",
      emailHeader: "#DBEAFE",
      cardBackground: "#FFFFFF",

      title: "#0F172A",
      subTitle: "#1D4ED8",
      body: "#475569",

      border: "#DBEAFE",
      total: "#2563EB",
      icon: "#2563EB",
    },

    typography: {
      ...defaultInvoiceCustomStyle.typography,
      fontFamily: "Inter",
      headingFontFamily: "Inter",
    },

    borders: {
      ...defaultInvoiceCustomStyle.borders,
      color: "#DBEAFE",
      width: 1,
      radius: 16,
      style: "solid",
    },

    spacing: {
      ...defaultInvoiceCustomStyle.spacing,
      cardGap: 16,
    },

    icons: {
      ...defaultInvoiceCustomStyle.icons,
      service: "cleaning",
      visits: "calendar",
      location: "location",
      notes: "document",
      payment: "payment",
      additionalCharges: "assignment",
    },
  },

  minimal: {
    ...cloneDefaultStyle(),

    colors: {
      ...defaultInvoiceCustomStyle.colors,

      pageBackground: "#FFFFFF",
      emailHeader: "#F9FAFB",
      cardBackground: "#FFFFFF",

      title: "#111827",
      subTitle: "#374151",
      body: "#4B5563",

      border: "var(--fx-surface-border, #E2E8F0)",
      total: "#111827",
      icon: "#111827",
    },

    typography: {
      ...defaultInvoiceCustomStyle.typography,
      fontFamily: "Inter",
      headingFontFamily: "Inter",
    },

    borders: {
      ...defaultInvoiceCustomStyle.borders,
      color: "#E5E7EB",
      width: 0,
      radius: 4,
      style: "solid",
    },

    spacing: {
      ...defaultInvoiceCustomStyle.spacing,
      cardGap: 8,
    },

    icons: {
      ...defaultInvoiceCustomStyle.icons,
      service: "none",
      visits: "none",
      location: "none",
      notes: "none",
      payment: "none",
      additionalCharges: "none",
    },
  },
};
